import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import { SexIndicatorBadge } from '@components/Track/SexIndicatorBadge'

type PropsType = {
  sexIndicatorTime: number | null,
  sexIndicatorText: string | null,
  lengthText: string
}

export function LengthInfo (props: PropsType): React.ReactNode {
  return (
    <LengthInfoContainer>
      <LengthText>Length: {props.lengthText}</LengthText>
      <IndicatorContainer>
        {props.sexIndicatorTime && <IndicatorBar><IndicatorAmount $indicatorTime={props.sexIndicatorTime}/></IndicatorBar>}
        {props.sexIndicatorText && <SexIndicatorBadge text={props.sexIndicatorText}/>}
      </IndicatorContainer>
    </LengthInfoContainer>
  )
}

const LengthText = styled.div<any>`
    font-family: "Good Sans Regular";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: -0.3px;
    color: ${colors.white};
    margin-right: 8px;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
    margin-right: 24px;
    font-size: 14px;
  `}
    ${(props: any): any => config(props).media.lg`
    margin-right: 36px;
    font-size: 16px;
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`

const LengthInfoContainer = styled.div<any>`
    display: flex;
    align-items: center;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`

const IndicatorContainer = styled.div<any>`
    display: flex;
    align-items: center;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`

const IndicatorBar = styled.div<any>`
    position: relative;
    width: 150px;
    height: 8px;
    background-color: ${colors.white25};
    border-radius: 4px;
    margin-right: 16px;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
    width: 232px;
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`

const IndicatorAmount = styled.div<any>`
    position: absolute;
    top: 0;
    right: 0;
    ${(props: any): string => {
  return `width: ${props.$indicatorTime}%;`
}};
    height: 8px;
    background-color: ${colors.white};
    border-radius: 4px;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`
